import { baseClient } from "./baseRequest";

export type OrderInfo = {
  data: {
    first_name: string;
    last_name: string;
    status_name: string;
    info: {
      serial_number: string[];
    }[];
  };
};

export type OrderClient = {
  getOrderInfo(orderName: string): Promise<OrderInfo>;
};

const orderClient: OrderClient = {
  getOrderInfo: async (orderName) => {
    return baseClient.get({
      url: `/orders/${orderName}`,
    });
  },
};

export default orderClient;
